var ww = window.innerWidth;
var wh = window.innerHeight;

if(ww < 1000){
  //ham
  const ham = document.querySelector('.c-ham');
  const nav = document.querySelector('.c-nav.--main');
  const html = document.querySelector('html');
  const navlinks = document.querySelectorAll('.c-nav__link.--inlink');
  ham.addEventListener('click', () => {
    ham.classList.toggle('active');
    nav.classList.toggle('active');
    html.classList.toggle('active');
  });
  navlinks.forEach(navlink => {
    navlink.addEventListener('click', () => {
      ham.classList.toggle('active');
      nav.classList.toggle('active');
      html.classList.toggle('active');
    });
  });
}


//sidenav
const sidenav = document.querySelector('.c-nav.--side');
if(sidenav){
  window.addEventListener("scroll", function () {
    const scroll = window.pageYOffset;
    if (scroll > 100) {
      sidenav.classList.add('active');
    } else {
      sidenav.classList.remove('active');
    }
  });
}


//cva
const cva = document.querySelector('.c-cva');
if(cva){
  window.addEventListener("scroll", function () {
    const scroll = window.pageYOffset;
    if (scroll > wh) {
      cva.classList.add('active');
    } else {
      cva.classList.remove('active');
    }
  });
}


//sp cva




//top kv slider pc
const topKVpc = new Swiper('.swiper.--top.--kv.--pc', {
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  speed: 5000,
  autoplay: {
    delay: 7000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
});

//top kv slider sp
const topKVsp = new Swiper('.swiper.--top.--kv.--sp', {
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  speed: 7000,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
});


//top message slide
if(ww < 600){
  const topMessage = new Swiper('.swiper.--top.--message', {
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 3000,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      waitForTransition: false,
    },
  });
}


//top aid slide
const topAid = new Swiper('.swiper.--top.--aid', {
  loop: true,
  effect: 'slide',
  /* fadeEffect: {
    crossFade: true,
  }, */
  speed: 3000,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  slidesPerView: 1,
  spaceBetween: 32,
  breakpoints: {
    600: {
      slidesPerView: 2,
      spaceBetween: 32,
    },
      1025: {
      slidesPerView: 3,
      spaceBetween: 32,
    }
  },
});



//aid photo slide
const AidSlide = document.querySelector('.swiper.--CourseAid');
if(AidSlide){
  if(ww < 600){
    const CourseAidSlide = new Swiper('.swiper.--CourseAid', {
      loop: true,
      effect: 'slide',
      speed: 3000,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        waitForTransition: false,
      },
      slidesPerView: 1,
      spaceBetween: 32,
    });
  }
}






//a blank
document.addEventListener('DOMContentLoaded', () => {
    LinkTargetBlankEvent();
  });
  const LinkTargetBlankEvent = () => {
    const domain = document.domain;
    const regexp = new RegExp(domain);
    const elements = document.querySelectorAll('a');
    elements.forEach(element => {
    let href = element.getAttribute('href');
    if (!href) { return; }
    const skipConditions = [
      href.startsWith('/'),
      href.startsWith('.'),
      href.startsWith('./'),
      href.startsWith('../'),
      href.startsWith('#'),
    ];
    if (skipConditions.some(condition => condition)) { return; }
    if (!regexp.test(href)) {
      element.setAttribute('target', '_blank');
      element.setAttribute('rel', 'noopener noreferrer');
    }
  });
};



//desvg
window.addEventListener('load', function(){
  deSVG('.desvg', true);
});


//body add class
document.body.classList.add('js-show');
